<template>
  <!-- <div class="home">
    <img alt="Vue logo" src="../assets/logo.png">
    <HelloWorld msg="Welcome to Your Vue.js App"/>
  </div> -->
  <div id="login-container" class="flex container mx-auto items-center justify-center" data-gr-c-s-loaded="true">
    <div class="w-full max-w-xs">
      <form
        @submit.prevent="submit" 
        class="bg-white shadow-md rounded px-8 pt-6 pb-8 mb-4">
        <img src="../assets/images/logo-auth.png" width="180" class="logo" />
        <div class="mb-4">
          <label class="block text-gray-700 text-sm font-bold mb-2" for="email">
            Email
          </label>
          <input class="shadow appearance-none border rounded w-full py-2 px-3 
            text-gray-700 leading-tight focus:outline-none focus:shadow-outline" 
            type="email" id="email" placeholder="Email" name="email" required
            v-model="form.email"
            />
          <p v-if="!isUsernameValid" class="text-red-500 text-xs italic">Username can consist of letters and numbers only!</p>
        </div>
        <div class="mb-6">
          <label class="block text-gray-700 text-sm font-bold mb-2" for="password">
            Senha
          </label>
          <input class="shadow appearance-none border rounded w-full 
            py-2 px-3 text-gray-700 leading-tight focus:outline-none 
            focus:shadow-outline" 
              type="password" id="password"
              placeholder="Senha" name="password" required v-model="form.password"
            />
        </div>
        <div class="flex items-center justify-between">
          <button class="w-full bg-blue-500 hover:bg-blue-700 text-white font-bold 
            py-2 px-4 rounded focus:outline-none focus:shadow-outline" type="submit" 
            >
            <i class="fas fa-lock pr-2"></i>
            Autenticar
          </button>
        </div>
        <div class="flex items-center justify-between mt-4">
          <p class="inline-block align-baseline text-sm text-blue-500">Não tem uma conta?
            <a class="inline-block align-baseline font-bold text-sm text-blue-500
              hover:text-blue-800" 
              >Quero me cadastrar
            </a>
          </p>
        </div>
      </form>
      <p class="text-center text-white text-xs">
        &copy;2020 ServerBot App by Allan Freitas. All rights reserved.
      </p>
    </div>
    <div v-if="error" class="notification bg-indigo-900 text-center py-4 lg:px-4">
      <div class="p-2 bg-indigo-800 items-center text-indigo-100 leading-none lg:rounded-full flex lg:inline-flex" role="alert">
        <span class="flex rounded-full bg-indigo-500 uppercase px-2 py-1 text-xs font-bold mr-3">ERROR</span>
        <span class="font-semibold mr-2 text-left flex-auto">{{error}}</span>
      </div>
    </div>
  </div>
</template>

<script>
import { mapActions } from 'vuex'
export default {
  name: 'Login',
  components: {
    
  },
  data: function(){
    return {
      isUsernameValid: true,
      error: null,
      form: {
        email: '',
        password: '',
      }
    }
  },
  methods: {
    ...mapActions({
      signIn: 'auth/signIn'
    }),

    submit () {
      this.signIn(this.form).then(() => {
        this.$router.replace({
          name: 'dashboard'
        })
      }).catch((e) => {
        console.log(e);
      })
    }
  }
}
</script>
